import React from "react";
import style from "../../Styles/Components/Section.module.css";

import Title from "./Title";

const Section = ({ title, children, customStyle = {} }) => (
  <section style={customStyle} className={style.section}>
    {title && <Title title={title} />}

    {children}
  </section>
);

export default Section;
